export default "__VITE_ASSET__DZVUUtcW__"